module.exports = __webpack_public_path__ + "img/TSLIC-Logo.b141429b.png";